'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.emitAddError = exports.initOwl = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Created by longjing on 17/10/12.
                                                                                                                                                                                                                                                                   */

var _owl = require('@dp/owl');

var _owl2 = _interopRequireDefault(_owl);

var _environment = require('./environment');

var _environment2 = _interopRequireDefault(_environment);

var _config = require('./config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * initOwl
 * @param options
 * {
 *      project: 建议使用前端项目名
 *      pageUrl: 默认为weidow.location.href
 *      devMode: 可选, 若传入则覆盖默认配置 ( 非线上模式统一上报到beta接口 )
 *      其他参数原样传入, 详情见文档: http://docs.sankuai.com/doc/f2e_dp/owl/deep/
 * }
 */
var initOwl = exports.initOwl = function initOwl(options) {

    window.Owl = _owl2.default;
    _owl2.default.start(_extends({ devMode: _environment2.default !== _config.PRODUCTION }, options));
};

var isObject = function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
};

var sendError = function sendError(name, category) {
    return function (_ref) {
        var msg = _ref.msg,
            _ref$level = _ref.level,
            level = _ref$level === undefined ? 'error' : _ref$level,
            tags = _ref.tags;

        _owl2.default.addError({ name: name, msg: msg }, {
            level: level,
            category: category,
            tags: tags
        });
        return true;
    };
};

var sendAjaxError = function sendAjaxError() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'fetch-error';
    return sendError(name, 'ajaxError');
};

var sendJSError = sendError('js-error', 'jsError');

var sendCustomJSError = function sendCustomJSError(name) {
    return sendError(name, 'jsError');
};

/**
 * addError
 * @param error
 * @param config 为其他信息对象,可选
 */
var emitAddError = function emitAddError() {
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var level = config.level,
        errorMessage = config.errorMessage,
        name = config.name,
        other = _objectWithoutProperties(config, ['level', 'errorMessage', 'name']);

    var options = {
        msg: error,
        tags: {
            other: other
        },
        level: level
    };
    // jsError: error 为 error 对象
    if (error instanceof Error) {
        var jsOptions = {
            msg: error.message,
            tags: {
                errorStack: error.stack,
                errorName: error.name,
                errorMessage: errorMessage,
                other: other
            }
        };
        return sendJSError(jsOptions);
    } else if (isObject(error)) {
        // ajaxError: error 包含请求信息对象 request 和返回信息对象 response
        var _error$request = error.request,
            request = _error$request === undefined ? {} : _error$request,
            _error$response = error.response,
            response = _error$response === undefined ? {} : _error$response;

        return sendAjaxError(name)(_extends({}, options, {
            msg: errorMessage,
            tags: _extends({}, options.tags, {
                request: request,
                response: response
            })
        }));
    } else {
        return sendCustomJSError(error)(_extends({}, options, {
            msg: errorMessage
        }));
    }
};

// 引用Owl其它方法
exports.emitAddError = emitAddError;
exports.default = _owl2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cp-component-lib/lib/owl.js
// module id = 242
// module chunks = 0